







import { Component, Prop, Vue } from 'vue-property-decorator';

import AuditConfig from '../components/AuditConfig.vue';
import Loading from '../components/Loading.vue';
import HttpServiceCompany from '../http/http-service-company';
import { Company } from '../models/company';
import { CompanyAuditConfig } from '../models/company-audit-config';

@Component({
  components: {
    AuditConfig,
    Loading,
  },
})
export default class ConfigAuditCompany extends Vue {
  @Prop()
  private company: Company;

  private companyConfigs: CompanyAuditConfig[] = [];

  private isLoading = false;

  private created() {
    this.initCompanyConfigs();
  }

  private async initCompanyConfigs() {
    this.companyConfigs = await this.getCompanyConfigs();
  }

  private async getCompanyConfigs() {
    this.isLoading = true;

    const response = await HttpServiceCompany.readAuditConfigs(this.company.id);

    this.isLoading = false;

    return response?.data || [];
  }

  private async onConfigChange(config: CompanyAuditConfig) {
    const { active, auditConfig } = config;

    this.isLoading = true;

    const response = await HttpServiceCompany.toggleAuditConfig(this.company.id, {
      active,
      auditConfigId: auditConfig.id,
    });

    this.isLoading = false;

    if (response) {
      this.storeChange();
      config.isOverwritten = !config.isOverwritten;
    }
  }

  private storeChange() {
    this.$store.state.companyAuditConfigs && this.$store.commit('setCompanyAuditConfigs', this.companyConfigs);
  }
}
